import { render, staticRenderFns } from "./GovernoratesList.vue?vue&type=template&id=1b020a90&scoped=true"
import script from "./GovernoratesList.vue?vue&type=script&lang=js"
export * from "./GovernoratesList.vue?vue&type=script&lang=js"
import style0 from "./GovernoratesList.vue?vue&type=style&index=0&id=1b020a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b020a90",
  null
  
)

export default component.exports